module.exports = __webpack_public_path__ + "html/mari-smith-tutorials_daf6efa014bc92a24b35e72a8eec07c9.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave/mari-smith-tutorials.html
// module id = wL/W
// module chunks = 31